import React from 'react';
import { useSelector } from 'react-redux';
import SignUpForm from '../SignUpForm';
import SignUpOnPageJump from '../SignUpOnPageJump';

import {
  SignUpFormWrapper,
  SignUpFormTitle,
} from './SignUpOnPage.styles';

export const SignUpOnPage = () => {
  const subscriber = useSelector(
    (state) => state.subscriber,
  );
  return (
    <SignUpFormWrapper>
      {
        !subscriber
          ? <>
            <SignUpFormTitle>
               Sign up to get your free daily horoscope delivered directly to your inbox.
            </SignUpFormTitle>
            <SignUpForm />
          </>
          : <SignUpOnPageJump email={subscriber.email} />
      }

    </SignUpFormWrapper>
  );
};


export default SignUpOnPage;

